import {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {MAX_CART_ITEM_QUANTITY} from './quantityLimit';
import '../../../Assets/Css/Pages/Cart/quantity_limit.css';

export function QuantityLimitError(): ReactElement {
    const {t, i18n} = useTranslation();

    return (
        <span className="cart-quantity-limit-error" role="alert">
            {t('cart.quantity-limit-exceeded', {maxQuantity: new Intl.NumberFormat(i18n.language).format(MAX_CART_ITEM_QUANTITY)})}
        </span>
    );
}
